import React, { useCallback, useEffect, useRef, useState } from "react";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../AbstractElements";
import { useGetAgendaControlType } from "../../Configuration/Agenda/UseAgenda";
import {
  useAddBrandCampaignStep,
  useGetAgendaSubType,
  useGetBrandStepList,
  useGetSGPIList,
  useGetSingleBrandCampaignStep,
  useUpdateBrandCampaignStep,
} from "./useBrandCampaignStep";
import { useGetBrandCampaignStatusData } from "../hooks/useBrandCampaign";
import NewDualList from "./Reubale_DualList/NewDualList";
import { showToast } from "../../../utils/toastUtils";
import { useNavigate } from "react-router-dom";

interface Props {
  BrandCampiagnVisitPlanId?: number;
  onClose: () => void;
  OrgIDFromBrandCampagin?: number;
  BrandCampiagnId?: number;
  mode: string;
  BrandCampiagnRowData?: any;
  BrandCampiagnStartDate?: any;
  BrandCampiagnEndDate?: any;
}

interface dropDownDateInteface {
  id: string;
  label: string;
}

const BrandCampaignStepModal: React.FC<Props> = ({
  BrandCampiagnVisitPlanId,
  onClose,
  OrgIDFromBrandCampagin,
  BrandCampiagnId,
  mode,
  BrandCampiagnRowData,
  BrandCampiagnStartDate,
  BrandCampiagnEndDate,
}) => {
  const navigate = useNavigate();
  const blockObserverRef = useRef(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (BrandCampiagnStartDate && BrandCampiagnEndDate) {
      Month18Data();
    }

    const debounceTimer = setTimeout(() => {
      if (search.trim() || search === "") {
        // Include empty search to reset
        SetAPISearch(search);
      }
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [BrandCampiagnStartDate, search]);

  const [length, setLength] = useState(10);
  const [APISearch, SetAPISearch] = useState("");
  const [dataForDateDropDown, setdataForDateDropDown] = useState<
    dropDownDateInteface[]
  >([]);

  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [formdata, setFormdata] = useState({
    AgendaType: mode === "edit" ? BrandCampiagnRowData.AgendaType : "",
    AgendaSubType: mode === "edit" ? BrandCampiagnRowData.AgendaSubTypeId : "",
    step: mode === "edit" ? BrandCampiagnRowData.Level : "",
    Name: mode === "edit" ? BrandCampiagnRowData.Name : "",
    Description: mode === "edit" ? BrandCampiagnRowData.Description : "",
    InputRequired: mode === "edit" ? BrandCampiagnRowData.SgpiStatus : false,
    date: mode === "edit" ? BrandCampiagnRowData.Moye : "",
    creatreSurvey: mode === "edit" ? BrandCampiagnRowData.CreateSurvey : false,
  });

  const { mutate: addBrandCampaignStep } = useAddBrandCampaignStep();
  const { mutate: updateBrandCampaignStep } = useUpdateBrandCampaignStep();
  const { data, isLoading, isSuccess } = useGetAgendaControlType({
    enabled: true,
  });

  const { data: singleBrandCampaginStep } = useGetSingleBrandCampaignStep({
    enable: true,
    id: mode === "edit" ? BrandCampiagnRowData.BrandCampiagnVisitPlanId : false,
  });

  const {
    data: SubAgendaType,
    isLoading: subAgendaLoading,
    isSuccess: subAgendaIssuccess,
  } = useGetAgendaSubType({
    enable: formdata.AgendaType ? true : false,
    params: {
      Orgunitid: Number(OrgIDFromBrandCampagin),
      agendaType: formdata.AgendaType,
    },
  });

  const {
    data: brandCampaignStatus,
    isLoading: brandCampaignStatusLoading,
    isSuccess: isSuccessBrandCampaignStatus,
  } = useGetBrandCampaignStatusData({ enable: true });

  const {
    data: stepBrandList,
    isLoading: stepBrandListLoading,
    isSuccess: stepBrandListSuccess,
  } = useGetBrandStepList({
    enable: mode === "add" ? true : false,
    params: {},
    id: mode === "add" ? BrandCampiagnId ?? null : null,
  });

  const {
    data: SGPIData,
    isLoading: SGPIISLoading,
    isSuccess: SGPIisSuccess,
  } = useGetSGPIList({
    enable: true,
    params: {
      start: 1,
      length: length,
      search: APISearch,
    },
  });

  useEffect(() => {
    if (formdata.InputRequired === true) {
      // Clear selected SGPI data when input is not required
      setRightListData([]);
      setInitalLeftSideData([]);
    }
  }, [formdata.InputRequired]);

  const Month18Data = () => {
    if (!BrandCampiagnStartDate || !BrandCampiagnEndDate) return;

    const start = new Date(BrandCampiagnStartDate);
    const end = new Date(BrandCampiagnEndDate);

    const date = new Date(BrandCampiagnStartDate);
    const month = date.getMonth(); // 0-based
    const year = date.getFullYear();

    // calculate total number of months between start and end (inclusive)
    const totalMonths =
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth()) +
      1;

    const MonthArray: dropDownDateInteface[] = [];

    for (let i = 0; i < totalMonths; i++) {
      const newDate = new Date(year, month + i, 1);
      const m = (newDate.getMonth() + 1).toString().padStart(2, "0");
      const y = newDate.getFullYear();
      const label = `${m}-${y}`;

      MonthArray.push({ id: label, label: label });
    }
    setdataForDateDropDown(MonthArray);
  };

  const dataForSteps = Object.entries(
    brandCampaignStatus?.data?.Steps || {}
  ).map(([id, label]) => ({ id: id, label: String(label) }));

  const excludedIds =
    stepBrandList?.stepLevelData?.map((item: any) => String(item.id)) || [];
  const filterStepData = dataForSteps.filter(
    (item) => !excludedIds.includes(String(item.id))
  );

  const handleForm = (e: any) => {
    e.preventDefault();
    setButtonDisable(true);
    if (mode === "add") {
      if (!formdata?.Name.trim()) {
        showToast.warning("Please Fill the Name Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.AgendaType) {
        showToast.warning("Please Select the Agenda Control Type Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.AgendaSubType) {
        showToast.warning("Please Select the Agenda Sub Type Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.step) {
        // formdata.date
        showToast.warning("Please Select the Step Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.date) {
        // formdata.date
        showToast.warning("Please Fill the Month / Year  Field!");
        setButtonDisable(false);
        return;
      } else {
        const sgpiForamteData = rightListData.map((item) => item.id);

        const ReqBody = {
          CampaignId: BrandCampiagnId,
          AgendaType: formdata.AgendaType,
          AgendaSubTypeId: Number(formdata.AgendaSubType),
          StepLevel: Number(formdata.step),
          StepName: formdata.Name,
          Description: formdata.Description,
          SgpiStatus: formdata.InputRequired,
          MonthYear: formdata.date,
          // MonthYear:'06-2025',
          SgpiId: sgpiForamteData,
          CreateSurvey: formdata.creatreSurvey,
        };

        addBrandCampaignStep(ReqBody, {
          onSuccess: (data: any) => {
            setButtonDisable(false);
            const surveyId = data?.data?.surveyId;

            if (formdata.creatreSurvey === true && surveyId) {
              setButtonDisable(false);
              navigate("/surveyQuestions", {
                state: { SurveyId: surveyId },
              });
              onClose();
              setFormdata((prev: any) => ({
                ...prev,
                AgendaType: "",
                AgendaSubType: "",
                step: "",
                Name: "",
                Description: "",
                InputRequired: false,
                date: "",
                creatreSurvey: false,
              }));
            } else {
              setButtonDisable(false);
              onClose();
              setFormdata((prev: any) => ({
                ...prev,
                AgendaType: "",
                AgendaSubType: "",
                step: "",
                Name: "",
                Description: "",
                InputRequired: false,
                date: "",
                creatreSurvey: false,
              }));
            }
          },
          onError: () => {
            setButtonDisable(false);
          },
        });
      }
    }

    if (mode === "edit") {
      setButtonDisable(true);
      if (!formdata?.Name.trim()) {
        showToast.warning("Please Fill the Name Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.AgendaType) {
        showToast.warning("Please Select the Agenda Control Type Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.AgendaSubType) {
        showToast.warning("Please Select the Agenda Sub Type Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.step) {
        showToast.warning("Please Select the Step Field!");
        setButtonDisable(false);
        return;
      } else if (!formdata?.date) {
        // formdata.date
        showToast.warning("Please Fill the Month / Year  Field!");
        setButtonDisable(false);
        return;
      } else {
        const sgpiForamteData = rightListData.map((item) => item.id);
        const ReqBody = {
          VisitPlanId: BrandCampiagnRowData.BrandCampiagnVisitPlanId,
          CampaignId: Number(BrandCampiagnId),
          AgendaType: formdata.AgendaType,
          AgendaSubTypeId: Number(formdata.AgendaSubType),
          StepLevel: Number(formdata.step),
          StepName: formdata.Name,
          Description: formdata.Description,
          SgpiStatus: formdata.InputRequired,
          MonthYear: formdata.date,
          // MonthYear:'06-2025',
          SgpiId: sgpiForamteData,
          CreateSurvey: formdata.creatreSurvey,
        };
        // console.log('ReqBody----->',ReqBody);
        updateBrandCampaignStep(ReqBody, {
          onSuccess: (data: any) => {
            setButtonDisable(false);
            const surveyId = data?.data?.surveyId;

            console.log(
              "🚀 ~ BrandCampaignStepModal.tsx:293 ~ handleForm ~ surveyId:",
              surveyId
            );

            if (formdata.creatreSurvey === true && surveyId) {
              setButtonDisable(false);
              navigate("/surveyQuestions", {
                state: { SurveyId: surveyId },
              });
              onClose();
              setFormdata((prev: any) => ({
                ...prev,
                AgendaType: "",
                AgendaSubType: "",
                step: "",
                Name: "",
                Description: "",
                InputRequired: false,
                date: "",
                creatreSurvey: false,
              }));
            } else {
              setButtonDisable(false);
              onClose();
              setFormdata((prev: any) => ({
                ...prev,
                AgendaType: "",
                AgendaSubType: "",
                step: "",
                Name: "",
                Description: "",
                InputRequired: false,
                date: "",
                creatreSurvey: false,
              }));
            }
          },
          onError: () => {
            setButtonDisable(false);
          },
        });
      }
    }
  };

  const handleInput = (fieldName: any, value: any) => {
    setFormdata((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  // New Dual List Component..
  const [rightListData, setRightListData] = useState<any[]>([]);
  const [initalLeftSideData, setInitalLeftSideData] = useState<any[]>([]);

  useEffect(() => {
    if (SGPIisSuccess && SGPIData?.data) {
      const timer = setTimeout(() => {
        blockObserverRef.current = false;
      }, 1000);

      setInitalLeftSideData((prev) => {
        // For fresh searches (when length=10), replace all data
        if (length === 10) {
          const rightIds = new Set(rightListData.map((item) => item.id));
          return SGPIData.data.filter((item) => !rightIds.has(item.id));
        }

        // For infinite scroll, merge with existing data
        const combineData = [...prev, ...SGPIData?.data];
        const uniqueByID = Array.from(
          new Map(combineData.map((item) => [item.id, item])).values()
        );

        const rightIds = new Set(rightListData.map((item) => item.id));
        return Array.from(uniqueByID).filter((item) => !rightIds.has(item.id));
      });

      setIsLoadingMore(false);
      return () => clearTimeout(timer);
    }
  }, [SGPIisSuccess, SGPIData?.data]);

  useEffect(() => {
    if (mode === "edit" && singleBrandCampaginStep?.formatedData) {
      setRightListData((prev) => {
        const newItems = singleBrandCampaginStep.formatedData.filter(
          (newItem: any) => !prev.some((item) => item.id === newItem.id)
        );
        return [...prev, ...newItems]; // <- flat merge
      });
    }
  }, [mode, singleBrandCampaginStep?.formatedData]);

  const handleLeftSideitem = (item: any) => {
    setInitalLeftSideData(initalLeftSideData.filter((it) => it.id !== item.id));
    setRightListData((prev) => [...prev, item]);
  };

  const handleRightSideitem = (item: any) => {
    setRightListData(rightListData.filter((it: any) => it.id !== item.id));
    setInitalLeftSideData((prev: any) => [...prev, item]);
  };

  const handleLeftbtn = () => {
    const newRightList = [...rightListData, ...initalLeftSideData];
    setRightListData(newRightList);
    setInitalLeftSideData([]);
  };

  const handleRightbtn = () => {
    const newRightSodeList = [...initalLeftSideData, ...rightListData];
    setInitalLeftSideData(newRightSodeList);
    setRightListData([]);
  };

  const handleSearchInputLeft = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputSearch = e.target.value;

    setSearch(inputSearch);
    blockObserverRef.current = true;
    setInitalLeftSideData([]);
  };

  const onReachEnd = useCallback(() => {
    if (!isLoadingMore && hasMoreData) {
      setIsLoadingMore(true);
      setTimeout(() => {
        setLength((prev: any) => {
          const newLength = prev + 10;
          return newLength;
        });
      }, 500);
    }
  }, [isLoadingMore, hasMoreData]);
  return (
    <form onSubmit={handleForm}>
      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          <ReusableDropdown
            options={(!isLoading && isSuccess && data?.data) || []}
            value={formdata.AgendaType}
            onChange={(opt) => handleInput("AgendaType", opt)}
            DropdownHeading="Agenda control Type"
            asterisk={true}
          />
        </div>
        <div className="col-sm-6 mt-0">
          <ReusableDropdown
            options={
              (!subAgendaLoading &&
                subAgendaIssuccess &&
                SubAgendaType?.data) ||
              []
            }
            value={formdata.AgendaSubType}
            asterisk={true}
            onChange={(opt) => handleInput("AgendaSubType", opt)}
            DropdownHeading="Agenda Sub Type"
          />
        </div>
      </div>

      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          <ReusableDropdown
            isDisabled={mode === "edit" ? true : false}
            options={filterStepData || []}
            value={formdata.step}
            asterisk={true}
            onChange={(opt) => handleInput("step", opt)}
            DropdownHeading="Step"
          />
        </div>

        <div className="col-sm-6">
          <CustomInput
            label="Name"
            asterisk={true}
            value={formdata.Name}
            onChange={(e) => handleInput("Name", e.target.value)}
            style={{ borderRadius: "4px" }}
          />
        </div>
      </div>

      <label htmlFor="description" style={{ color: "black" }}>
        Description
      </label>

      <div className="row mb-0 col-sm-12" style={{ padding: 10 }}>
        <textarea
          style={{ borderRadius: "4px" }}
          className="form-control"
          placeholder="Enter description..."
          onChange={(e) => handleInput("Description", e.target.value)}
          value={formdata.Description}
          rows={2}
        ></textarea>
      </div>

      <div
        className="row mb-0 col-sm-12 mt-3"
        style={{ justifyContent: "center", alignItems: "center" }}
      >
        {/* Checkbox */}
        <div className="col-sm-6">
          <input
            type="checkbox"
            style={{ marginRight: 10 }}
            checked={formdata.InputRequired}
            onChange={(e) => handleInput("InputRequired", e.target.checked)}
          />
          <label>No input required</label>
        </div>

        {/* Date Label */}
        <div
          className="col-sm-6"
          style={{ marginLeft: 0, marginTop: -20, zIndex: 2 }}
        >
          <ReusableDropdown
            options={dataForDateDropDown || []}
            value={formdata.date}
            onChange={(opt) => handleInput("date", opt)}
            DropdownHeading="Month/Year"
            asterisk={true}
          />
        </div>
      </div>

      {formdata?.InputRequired === false && (
        <div className="row mb-0 col-sm-12" style={{ padding: 2 }}>
          <label style={{ color: "black" }}>Inputs</label>
          {/*  New Dual List */}
          <NewDualList
            LeftListOptionData={initalLeftSideData || []}
            RightListOptionData={rightListData}
            leftSideitem={handleLeftSideitem}
            rightSideitem={handleRightSideitem}
            handleLeftbtn={handleLeftbtn}
            handleRightbtn={handleRightbtn}
            handleSearchInputLeft={handleSearchInputLeft}
            // handleSearchInputRight={handleSearchInputRight}
            onReachEnd={onReachEnd}
            blockObserverRef={blockObserverRef}
          />
        </div>
      )}

      <div className="col-sm-6 mt-2" style={{ marginBottom: -10 }}>
        <input
          type="checkbox"
          style={{ marginRight: 10 }}
          checked={formdata.creatreSurvey}
          onChange={(e) => handleInput("creatreSurvey", e.target.checked)}
        />
        <label>Create Survey</label>
      </div>

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={buttonDisable}
        >
          {mode === "add" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={() => onClose()}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default React.memo(BrandCampaignStepModal);
